
const digest = '0b15a439a6ad8f91c9936ef0b22d1537f01f5965bc202447592dde68b8b5dca6';
const classes = {"wrapper":"_wrapper_13gtx_1","content":"_content_13gtx_9","title":"_title_13gtx_16","controls":"_controls_13gtx_19"};
const css = `._wrapper_13gtx_1 {
  font-family: Rubik, sans-serif;
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_13gtx_1 ._content_13gtx_9 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
  justify-content: center;
}
._wrapper_13gtx_1 ._content_13gtx_9 ._title_13gtx_16 {
  font-weight: 600;
}
._wrapper_13gtx_1 ._controls_13gtx_19 {
  min-width: 300px;
  max-width: 300px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: row;
  text-align: center;
  padding: 24px;
  gap: 24px;
  justify-content: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  